<template>
  <div class="d-flex">
    <b-nav-item class="d-md-down-none">
      <!-- <span>Xin chào, Admin</span> -->
    </b-nav-item>
    <AppHeaderDropdown right no-caret>
      <template slot="header" class="noti">
        <i class="icon-font icon-font-shake fas fa-bell fa-lg"></i>
        <div class="noti__counts">10</div>
      </template>
      <template slot="dropdown">
        <b-dropdown-item> Đây là thông báo </b-dropdown-item>
      </template>
    </AppHeaderDropdown>
    <AppHeaderDropdown right no-caret>
      <template slot="header">
        <i class="icon-font icon-font-round fas fa-cog fa-lg"></i>
      </template>
      <!-- <template slot="header">
        <strong>Admin</strong>
        <img :src="'img/user.png'" class="img-avatar" />
      </template> -->
      <template slot="dropdown" class="dropdown-menu-length">
        <b-card :no-body="true" class="mb-0 header-card-account">
          <b-card-body class="p-3 clearfix">
            <!-- <i class="icon-user bg-primary p-3 font-2xl mr-3 float-left"></i> -->
            <div class="mr-3 float-left">
              <img src="../img/user.png" class="img-avatar" width="50" />
            </div>
            <div></div>
            <div class="h6 text-info mb-0 mt-2 mb-1">
              {{ currentUser ? currentUser.account : "Chưa có thông tin" }}
            </div>
            <div class="font-xs text-muted text-uppercase bold-500">
              {{
                currentUser ? currentUser.roles.join(", ") : "Chưa có thông tin"
              }}
            </div>
          </b-card-body>
        </b-card>
        <b-dropdown-item @click="fn_changePassword()">
          <i class="fa-regular fa-key-skeleton"></i>
          Đổi mật khẩu
        </b-dropdown-item>
        <b-dropdown-item href="https://viettoc.test2.siten.vn/" target="_blank">
          <i class="fa-regular fa-browser"></i>
          Landing page
        </b-dropdown-item>
        <b-dropdown-item @click="fn_logout()">
          <i class="fa-regular fa-sign-out-alt"></i>
          Đăng xuất
        </b-dropdown-item>
      </template>
    </AppHeaderDropdown>
  </div>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";

import AuthService from "../service/AuthService";
import LanguageService from "../service/LanguageService";
import MethodService from "../service/MethodService";
export default {
  name: "DefaultHeaderDropdownSetting",
  components: {
    AppHeaderDropdown,
  },
  data: () => {
    return {
      aLang: LanguageService.lang,
      itemsCount: 0,
      currentUser: "",
      mData: {},
    };
  },
  methods: {
    async fn_getAccount() {
      this.currentUser = MethodService.getCurrentUser();
      console.log("Thông tin người dùng");
      console.log(this.currentUser);
    },
    fn_changePassword() {
      window.location.href = "/auth/resetPassword";
    },
    fn_logout() {
      this.$confirm(LanguageService.lang.logout, {
        confirmButtonText: LanguageService.lang.c_yes,
        cancelButtonText: LanguageService.lang.c_no,
        type: "info",
      })
        .then(() => {
          AuthService.logout(false)
            .then((res) => {
              this.$message({
                showClose: true,
                message: this.aLang.logout_success,
                type: "success",
                duration: 2000, //8s
              });
              window.localStorage.clear();
              let urlLogin = location.origin + "/auth/login";
              window.location.replace(urlLogin);
            })
            .catch((error) => {
              this.$message({
                showClose: true,
                message: this.aLang.logout_error,
                type: "error",
              });
            });
        })
        .catch();
    },
    fn_setRole() {},
  },
  created() {},
  mounted() {
    this.fn_getAccount();
  },
};
</script>
<style lang="scss">
.noti {
  position: relative;
  &__counts {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    background-color: #e0ab45;
    font-size: 12px;
    border-radius: 50%;
    position: absolute;
    font-weight: bold;
    top: 0;
    left: 25px;
    border: 2px solid #9e1c1e;
  }
}
.dropdown-item {
  transition: 0.3s;
}
.dropdown-item:hover {
  background-color: none;
}
.dropdown-menu li:hover {
  background-color: #f1f1f1;
}
.dropdown-menu li {
  position: relative;
  overflow: hidden;
  transition: 0.3s;
}
.dropdown-menu li::before {
  z-index: 1;
  content: "";
  position: absolute;
  top: -13px;
  left: 0;
  background-color: #e0ab45;
  width: 5px;
  height: 60%;
  transform: translateY(-50%);
  border-radius: 10px;
  transition: 0.3s;
}
.dropdown-menu li:hover::before {
  top: 50%;
}
.dropdown-menu {
  min-width: 300px;
}
.dropdown-item i {
  color: #000;
}
.app-header .dropdown-item {
  min-width: 157px;
}
.icon-font {
  color: #fff;
  transition: 0.2s;
  font-size: 22px;
  transition: 0.5s;
}

.icon-font-round:hover {
  transform: rotate(90deg);
  color: #e0ab45;
}
.sidebar .sidebar-minimizer::before {
  content: "\f0a8";
  font-family: "Font Awesome 6 Pro";
  background-image: none;
  font-size: 20px;
  color: #e0ab45;
  transition: 0.3s;
}
.d-md-down-none span {
  color: #fff;
}

.nav-item:hover .icon-font-shake {
  transform: rotate(20deg);
  color: #e0ab45;
}
@media screen and (max-width: 576px) {
  .el-message-box {
    width: 90%;
  }
}
@media (max-width: 415px) {
  .hide-name {
    display: none;
  }
}
</style>
